import { HttpClient } from '@angular/common/http';
import { inject } from '@angular/core';
import { Users } from '@types-lib';
import { ClinicEnvironment, ENVIRONMENT } from 'environments';
import { Observable } from 'rxjs';

export class LoggedInUserDetailsEndpoint {
  private env = inject<ClinicEnvironment>(ENVIRONMENT);
  httpClient = inject(HttpClient);

  get(): Observable<Users.User> {
    return this.httpClient.get<Users.User>(`${this.env.constants.api_url}users/me/details`)
  }
}
